import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../auth/service/auth';
import { map, take, filter } from 'rxjs/operators';

export const noAuthGuard: CanActivateChildFn = (route, state) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	
	// Wait for Firebase auth state to be initialized, then check authentication
	return authService.authInitialized$.pipe(
		filter(isInitialized => isInitialized), // Only proceed when auth is initialized
		take(1),
		map((isInitialized) => {
			
			// Check if user is authenticated after auth state is initialized
			if (authService.isAuthenticated()) {
				// User is authenticated, redirect to home
				return router.createUrlTree(['/app/home']);
			}
			
			// User is not authenticated, allow access to auth pages
			return true;
		})
	);
};

